import { useBi } from '../../../contexts/bi-context';
import { servicesUoUAppointmentSchedulingFormFieldLoadClicksSrc16Evid40 } from '@wix/bi-logger-bookings-data/v2';
import { useAppointmentContext } from '../context/appointment-context';
import { useConfig } from '../../../contexts/config-context';
export const getDefaultBiData = service => {
  var _service$form;
  return {
    bookingsServiceId: service == null ? void 0 : service.id,
    formGuid: service == null || (_service$form = service.form) == null ? void 0 : _service$form.id,
    serviceProperties: getServiceProperties(service)
  };
};
export const getServiceProperties = service => {
  var _service$locations;
  return JSON.stringify({
    serviceId: service == null ? void 0 : service.id,
    serviceType: service == null ? void 0 : service.type,
    locationIds: service == null || (_service$locations = service.locations) == null ? void 0 : _service$locations.map(location => location.id).filter(id => id),
    staffMemberIds: service == null ? void 0 : service.staffMemberIds,
    isOfferedAsPricingPlan: false
  });
};
export const useAppointmentBi = serviceToUse => {
  var _appointmentFieldProp;
  const {
    appointmentFieldProps
  } = useAppointmentContext();
  const {
    isEditor,
    isComposer
  } = useConfig();
  const bi = useBi();
  const service = serviceToUse || (appointmentFieldProps == null || (_appointmentFieldProp = appointmentFieldProps.initialData) == null ? void 0 : _appointmentFieldProp.service);
  if (isEditor || isComposer) {
    return;
  }
  return {
    ...bi,
    report: overrideParams => bi == null ? void 0 : bi.report(servicesUoUAppointmentSchedulingFormFieldLoadClicksSrc16Evid40({
      ...getDefaultBiData(service),
      ...overrideParams
    }))
  };
};
//# sourceMappingURL=bi.js.map